export const Education_data = [
      {
        instituteName: 'Thakur college of science & commerce (Degree College)',
        startYear:'2015',
        endYear:'2018',
        percentage: '76.06',
        course:'Bsc IT'
      },
      {
        instituteName: 'Thakur college of science & commerce (Junior College)',
        startYear:'2013',
        endYear:'2015',
        percentage: '85.38',
        course:'HSC (XII)'
      },
      {
        instituteName: 'Samata Vidya Mandir',
        startYear:'2003',
        endYear:'2013',
        percentage: '67.09',
        course:'General'
      },
    ]